import React, { useState } from 'react';
import { Alert, Button, Form, Input, Space, Typography } from 'antd';

const { TextArea } = Input;
const { Text } = Typography;

interface ITARContactSalesFormProps {
    onSubmit: (message: string) => Promise<void> | void;
    loading?: boolean;
}

export const ITARContactSalesForm: React.FC<ITARContactSalesFormProps> = ({ onSubmit, loading = false }) => {
    const [message, setMessage] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async () => {
        if (!message.trim()) return;
        setSubmitting(true);
        try {
            await onSubmit(message.trim());
            setSubmitted(true);
        } finally {
            setSubmitting(false);
        }
    };

    if (submitted) {
        return (
            <Alert
                data-testid="itar-contact-success"
                type="success"
                showIcon
                message="Message sent"
                description="Your message has been sent to your sales representative. They will be in touch shortly."
            />
        );
    }

    return (
        <div data-testid="itar-contact-sales-form">
            <Space direction="vertical" style={{ width: '100%' }}>
                <Text strong>Contact your sales representative</Text>
                <Text type="secondary">Subject: <Text>PartsBadger ITAR Form</Text></Text>
                <Form layout="vertical">
                    <Form.Item label="Message">
                        <TextArea
                            aria-label="Message"
                            rows={4}
                            value={message}
                            onChange={e => setMessage(e.target.value)}
                            placeholder="Describe your ITAR project and what you need quoted..."
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            onClick={handleSubmit}
                            loading={submitting || loading}
                            disabled={!message.trim()}
                        >
                            Send message
                        </Button>
                    </Form.Item>
                </Form>
            </Space>
        </div>
    );
};
